/** /invite?token=… (STORY-021): a signed-in teacher accepts an institution invite. */
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useSession } from "../auth/SessionContext";
import { product } from "../product";
import { acceptInvite } from "../teacher/api";
import { Button } from "../ui";

export function InviteAccept() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { principal } = useSession();
  const { token } = useSearch({ strict: false }) as { token?: string };
  const [state, setState] = useState<"idle" | "busy" | "failed">("idle");
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col gap-4 p-6">
      <p className="wordmark text-lg" translate="no">{product.name}</p>
      <h1 className="display text-2xl">{t("invite.title")}</h1>
      <p className="text-[color:var(--ink-2)]">{t("invite.body")}</p>
      {!principal ? (
        <p>{t("invite.signIn")} <Link to="/signin" className="underline">{t("signin.cta")}</Link></p>
      ) : (
        <Button
          block
          loading={state === "busy"}
          disabled={!token}
          onClick={async () => {
            setState("busy");
            try {
              await acceptInvite(token ?? "");
              void navigate({ to: "/t" });
            } catch {
              setState("failed");
            }
          }}
        >
          {t("invite.accept")}
        </Button>
      )}
      {state === "failed" && <p role="alert" style={{ color: "var(--danger)" }}>{t("invite.failed")}</p>}
    </main>
  );
}
